import Graph from "../graph";

import { Line } from "react-chartjs-2";
import { getGeneralInfo } from "api/legacy_performance";
import { questionnaires as questionnaireFixtures } from "../fixtures";
import { customTooltip } from "@lib/chartjs_tooltip";
import { isMobile } from "utils/browser";
import clsx from "clsx";

import { useState, useEffect } from "react";
import { useMounted } from "hooks/react";
import { useUser } from "hooks/user";

export default function GeneralPerformance(): JSX.Element {
  const [questionnaires, setQuestionnaires] = useState(questionnaireFixtures);
  const [loading, setLoading] = useState(true);
  const { user } = useUser();

  const mounted = useMounted();

  useEffect(() => {
    if (!mounted) return;
    if (!user) return setLoading(false);

    fetchData();
  }, [mounted, user]);

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: { display: false },
      tooltip: customTooltip(tooltipLabel, tooltipValue)
    },
    scales: {
      y: {
        display: true,
        min: 0,
        max: 100
      },
      x: {
        display: true,
        grid: { display: false }
      }
    }
  };

  function fetchData() {
    getGeneralInfo().then((response) => {
      setQuestionnaires(response.body);
      setLoading(false);
    });
  }

  function chartData() {
    const chartLabels = questionnaires.map(
      (q) => q.completedAt.match(/\d+\/\d+/)[0]
    );
    const data = questionnaires.map((q) => q.averageUntilThis * 100);
    return {
      labels: chartLabels,
      datasets: [
        {
          data: data,
          backgroundColor: "rgba(255,255,255, 0.0)",
          borderColor: color(),
          borderWidth: 2,
          pointBackgroundColor: "white",
          pointRadius: 4,
          pointHoverRadius: 8,
          pointHitRadius: 16,
          pointHoverBorderColor: color(),
          pointHoverBorderWidth: 2,
          pointHoverBackgroundColor: "#fff",
          lineTension: 0.4
        }
      ],
      options
    };
  }

  function color() {
    return user ? "#FFAC00" : "#999999";
  }

  function LineChart() {
    const heightProp = mounted && isMobile() ? { height: 250 } : {};
    return <Line data={chartData()} options={options} {...heightProp} />;
  }

  function tooltipLabel(pointIndex) {
    const questionnaire = questionnaires[pointIndex];
    const date =
      questionnaire.completedAt.split("/")[0] +
      "/" +
      questionnaire.completedAt.split("/")[1];
    return `Média acumulada<br />no dia ${date}`;
  }

  function tooltipValue(pointIndex) {
    const questionnaire = questionnaires[pointIndex];
    return `${Math.round(questionnaire.averageUntilThis * 100)}%`;
  }

  return (
    <Graph
      title="Performance geral"
      loading={loading}
      className={clsx("2xl:h-[410px] md:h-[385px]", {
        "filter grayscale": !user
      })}
    >
      <LineChart />
    </Graph>
  );
}
